import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService } from 'modules/core/services/auth.service';
import { CurrentUser } from 'modules/shared/models/account.models';
import { SearchType } from 'modules/shared/models/screening.models';

import { AppState } from 'store/root-reducer';
import * as AuthActions from 'store/actions/auth.actions';

import { environment } from 'environment/environment';

@Component({
  selector: 'artemis-dow-jones2-ver2-detail',
  templateUrl: './dow-jones2-ver2-detail.component.html',
  styleUrls: ['./dow-jones2-ver2-detail.component.scss']
})
export class DowJones2Ver2DetailComponent implements OnInit {

  private _apiBase: string = environment.API_BASE;
  private _currentToken: string;
  dj2DetailData: any;
  recordType: string;
  lengthAllKeyObjectInArray: number = 0;
  allKeyObjectInArray: Array<string> = [];

  constructor(private dialogRef: MatDialogRef<any>,
              private authService: AuthService,
              private store: Store<AppState>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    const data = _.cloneDeep(this.data);
    if (data) {
      this.recordType = this.data.recordType;
      if (data.searchResponse) {
        data.searchResponse = this.formatDj2DetailDataSearchResponse(data.searchResponse);
      }
      this.dj2DetailData = data;

      this.authService.getUser(true)
      .pipe(
        map((user: CurrentUser) => user),
        catchError((err: any) => {
          if (err === 'NotAuthenticated') {
            this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: false }));
            return of(null);
          } else {
            return throwError(err);
          }
        })
      )
      .subscribe((user: any) => {
        if (user) {
          this._currentToken = user.signInUserSession.accessToken.jwtToken;
        }
      });
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  convertUrlWithAscensionNumber(url: string): string {
    const textSearch = '(AN=';
    const isExistAN = url.includes(textSearch);
    const urlDefault = 'https://global.factiva.com/redir/default.aspx?P=sa&AN=';
    if (isExistAN) {
      let indexOfAN = url.indexOf(textSearch);
      let lengthUrl = url.length;
      url = urlDefault + url.slice(indexOfAN += 4, lengthUrl -= 1);
    }
    return url;
  }

  isTextValid(str: string): boolean {
    const isUrl = str.includes('http');
    const textSearch = '(AN=';
    const isExistAN = str.includes(textSearch);
    if (isUrl || isExistAN) {
      return true;
    } else {
      return false;
    }
  }

  downloadPDF() {
    // tslint:disable-next-line:max-line-length
    window.location.href = `${this._apiBase}/api/pdfs/${this.data.scanType === SearchType.QUICKSCAN  ? 'quickscan/' : ''}dow_jones2/${this.dj2DetailData.id}/?authorization=${this._currentToken}`;
  }

  formatDj2DetailDataSearchResponse(searchResponse: any) {
    if (searchResponse.state_owned_companies_content && searchResponse.state_owned_companies_content['stake-level-details']
      && (searchResponse.state_owned_companies_content['stake-level-details'].length > 0)) {
      const stakeLevelDetails = searchResponse.state_owned_companies_content['stake-level-details'].map((stakeLevelDetail: any) => {
        stakeLevelDetail =  {
          ...stakeLevelDetail,
          from: (stakeLevelDetail['since-day'] || '-') + '/' + (stakeLevelDetail['since-month'] || '-') + '/' + (stakeLevelDetail['since-year'] || '-'),
          to: (stakeLevelDetail['to-day'] || '-') + '/' + (stakeLevelDetail['to-month'] || '-') + '/' + (stakeLevelDetail['to-year'] || '-')
        };
        delete stakeLevelDetail['since-day'];
        delete stakeLevelDetail['since-month'];
        delete stakeLevelDetail['since-year'];
        delete stakeLevelDetail['to-day'];
        delete stakeLevelDetail['to-month'];
        delete stakeLevelDetail['to-year'];
        return stakeLevelDetail;
      });
      searchResponse.state_owned_companies_content['stake-level-details'] = stakeLevelDetails;
    }

    if (searchResponse.watchlist_content) {
      const watchlistContent = searchResponse.watchlist_content;

      if (watchlistContent['role-details'] && (watchlistContent['role-details'].length > 0)) {
        const roleDetails = watchlistContent['role-details'].map((roleDetail: any) => {
          roleDetail = {
            ...roleDetail,
            from: (roleDetail['since-day'] || '-') + '/' + (roleDetail['since-month'] || '-') + '/' + (roleDetail['since-year'] || '-'),
            to: (roleDetail['to-day'] || '-') + '/' + (roleDetail['to-month'] || '-') + '/' + (roleDetail['to-year'] || '-')
          };
          delete roleDetail['since-day'];
          delete roleDetail['since-month'];
          delete roleDetail['since-year'];
          delete roleDetail['to-day'];
          delete roleDetail['to-month'];
          delete roleDetail['to-year'];
          return roleDetail;
        });
        watchlistContent['role-details'] = roleDetails;
      }

      if (watchlistContent && watchlistContent['sanctions-references-details']
          && (watchlistContent['sanctions-references-details'].length > 0)) {
        const sanctionsReferencesDetails = watchlistContent['sanctions-references-details'].map((sanctionsReferencesDetail: any) => {
          sanctionsReferencesDetail = {
            ...sanctionsReferencesDetail,
            from: (sanctionsReferencesDetail['since-day'] || '-') + '/' + (sanctionsReferencesDetail['since-month'] || '-') + '/'
                + (sanctionsReferencesDetail['since-year'] || '-'),
            to: (sanctionsReferencesDetail['to-day'] || '-') + '/' + (sanctionsReferencesDetail['to-month'] || '-') + '/'
                + (sanctionsReferencesDetail['to-year'] || '-')
          };
          delete sanctionsReferencesDetail['since-day'];
          delete sanctionsReferencesDetail['since-month'];
          delete sanctionsReferencesDetail['since-year'];
          delete sanctionsReferencesDetail['to-day'];
          delete sanctionsReferencesDetail['to-month'];
          delete sanctionsReferencesDetail['to-year'];
          return sanctionsReferencesDetail;
        });
        watchlistContent['sanctions-references-details'] = sanctionsReferencesDetails;
      }

    }


    return searchResponse;
  }

  isArray(data: any): boolean {
    return Array.isArray(data);
  }

  isObject(data: any): boolean {
    return (typeof data === 'object') && (data !== null) && !(Array.isArray(data));
  }

  getKeyObject(data: Object): Array<any> {
    return Object.keys(data).sort();
  }

  getAllKeyObjectInArray(data: any): Array<any> {
    const arrKey: Array<string> = [];
    data.forEach((obj: object) => {
      Object.keys(obj).forEach((item: string) => {
        const index = arrKey.findIndex(key => key === item);
        if (index === -1 ) {
          arrKey.push(item);
        }
      });
    });
    this.allKeyObjectInArray = arrKey;
    this.lengthAllKeyObjectInArray = arrKey.length;
    return arrKey.sort();
  }

  convertTextTitleAndHeader(text: string): string {
    const result: string = text.split('-').join(' ');
    return result.split('_').join(' ');
  }
}
